import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

// RentUpdateProposalDto (Módulo 5) — proposta de atualização anual de renda [5.4.3].
// camelCase pinado a partir do contrato do backend.
export interface RentUpdateProposal {
  id: number;
  rentalContractId: number;
  contractNumber: string | null;
  propertyName: string;
  tenantName: string;
  effectiveDate: string;
  currentRent: number;
  coefficientPercent: number;
  proposedRent: number;
  // Estado: "proposta" | "aplicada" | "rejeitada".
  status: string;
  notifiedByEmail: boolean;
  notifiedAt: string | null;
  notes: string | null;
}

// Corpo de POST /api/rent-updates.
export interface CreateRentUpdatePayload {
  rentalContractId: number;
  effectiveDate: string;
  coefficientPercent: number;
  notes?: string | null;
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(response.status, text || response.statusText);
  }

  return (await response.json()) as T;
}

// Propostas de atualização de um contrato, desc por data de efeito.
export function getRentUpdateProposals(
  rentalContractId: number,
): Promise<RentUpdateProposal[]> {
  return request<RentUpdateProposal[]>(
    `/api/rent-updates?rentalContractId=${rentalContractId}`,
  );
}

// Cria uma nova proposta a partir de um coeficiente manual.
export function createRentUpdateProposal(
  payload: CreateRentUpdatePayload,
): Promise<RentUpdateProposal> {
  return request<RentUpdateProposal>("/api/rent-updates", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

// Aplica a proposta — atualiza a renda mensal do contrato.
export function applyRentUpdateProposal(
  id: number,
): Promise<RentUpdateProposal> {
  return request<RentUpdateProposal>(`/api/rent-updates/${id}/apply`, {
    method: "POST",
  });
}

// Notifica o inquilino por email (stub/log).
export function notifyRentUpdateProposal(
  id: number,
): Promise<RentUpdateProposal> {
  return request<RentUpdateProposal>(`/api/rent-updates/${id}/notify`, {
    method: "POST",
  });
}

export async function deleteRentUpdateProposal(id: number): Promise<void> {
  const response = await fetch(`${apiBaseUrl}/api/rent-updates/${id}`, {
    method: "DELETE",
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(response.status, text || response.statusText);
  }
}
